import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { Button, Form, FormFeedback, FormGroup, Input, InputGroupAddon } from 'reactstrap';
import { Link } from 'react-router-dom';
class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onUsernameChange = this.onUsernameChange.bind(this);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onSendSms = this.sendSms.bind(this);
    this.timer = '30';
    this.userData = JSON.parse(localStorage.getItem('2fa-auth'));
    this.state = {
      showPass: false,
      seconds: this.timer,
      disableSendSms: false,
      disableSendEmail: false,
      disable2FaOtp: false,
      authMode:  this.userData?.default2fa || 'email',
      isLoading: false,
      password:""
    };
  }

  onFormSubmit(ev) {
    ev.preventDefault();
    const { authMode } = this.state;
    const { username, password, onLogin, type } = this.props;
    onLogin(username, password, type, authMode);
  }

  onUsernameChange(ev) {
    const email = ev.target.value;
    this.props.onLoginDataChange(email, this.props.password);
  }

  onPasswordChange(ev) {
    if(ev.preventDefault)
    ev.preventDefault();
    const password = ev.target.value;
    this.setState({ password })
    this.props.onLoginDataChange(this.props.username, password);
  }

  componentDidMount() {
    const { authMode } = this.state
    const { type } = this.props
    if(type === '2fa') {
      if (authMode === 'sms') {
        this.sendSms()
       } else if (authMode === 'email') {
        this.sendEmail()
      } else if (authMode === '2factorapp') {
        this.on2FaApp()
      }
    }
  }

  sendSms() {
    console.log(window.OTPCredential)
    if ('OTPCredential' in window) {
      navigator.credentials
        .get({ otp: { transport: ['sms'] } })
        .then(otp => {
          this.onPasswordChange({ target: { value: otp.code } });
        })
        .catch(error => {
          console.error('Error retrieving OTP:', error);
        });
    }
    clearInterval(this.myInterval);
    this.setState({ 
      disableSendSms: true, 
      disableSendEmail: false,   
      disable2FaOtp: false,
      seconds: this.timer,
      authMode: 'sms' });
    this.props.onSendOtp();
    this.myInterval = setInterval(() => {
      this.setState(
        ({ seconds }) => ({
          seconds: seconds - 1,
        }),
        () => {
          if (this.state.seconds === 0) {
            this.setState({
              disableSendSms: false, 
              seconds: this.timer,
            });
            clearInterval(this.myInterval);
          }
        },
      );
    }, 1000);
  }

  sendEmail = () => {
    clearInterval(this.myInterval);
    this.setState({ 
      disableSendEmail: true, 
      disableSendSms: false, 
      disable2FaOtp: false, 
      seconds: this.timer,
      authMode: 'email' });
    this.props.onSendEmailOtp();
    this.myInterval = setInterval(() => {
      this.setState(
        ({ seconds }) => ({
          seconds: seconds - 1,
        }),
        () => {
          if (this.state.seconds === 0) {
            this.setState({
              disableSendEmail: false,
              seconds: this.timer
            });
            clearInterval(this.myInterval);
          }
        },
      );
    }, 1000);
  };

  on2FaApp = () => {
    clearInterval(this.myInterval);
    this.setState({ 
      disable2FaOtp: true, 
      disableSendEmail: false, 
      disableSendSms: false, 
      seconds: this.timer,
      authMode: '2factorapp' })
    this.myInterval = setInterval(() => {
      this.setState(
        ({ seconds }) => ({
          seconds: seconds - 1,
        }),
        () => {
          if (this.state.seconds === 0) {
            this.setState({
              seconds: this.timer,
              disable2FaOtp: false
            });
            clearInterval(this.myInterval);
          }
        },
      );
    }, 1000);
  }

  render() {
    const { type, password, username } = this.props;
    const { disableSendEmail, seconds, showPass, disableSendSms, disable2FaOtp } = this.state;
  
    return (
      <Form onSubmit={this.onFormSubmit} style={{ position: 'relative' }}>
        <FormGroup>
          <Input
            className="input-field"
            type="email"
            id="email"
            name="email"
            disabled={type === '2fa'}
            onChange={this.onUsernameChange}
            value={type === '2fa' ? this.userData.email : username}
            placeholder="Email"
            required
          />
          {/* {type !== '2fa' ? <FormFeedback>* This field is required</FormFeedback> : null} */}
        </FormGroup>
        <FormGroup>
          <Input
            className="input-field"
            id={(type === '2fa') ? '2fa' : 'password'}
            type={(showPass || type === '2fa') ? 'text' : 'password'}
            name="password"
            onChange={this.onPasswordChange}
            placeholder={type === '2fa' ? 'Verification Token' : 'Password'}
            required
            // autocomplete="off"
            style={{ borderRight: '0px !important' }}
            autoFocus={type === '2fa'}
            autocomplete={(type === '2fa')?"one-time-code":"off"}
            value={this.state.password}
          />
          {type !== '2fa' && <InputGroupAddon
            addonType="append"
            className="show-password"
            onClick={() => this.setState({ showPass: !showPass })}
          >

            <FontAwesomeIcon icon={!showPass ? 'eye-slash' : 'eye'} size="lg" color="#8998ac" />
          </InputGroupAddon>}
          {/* <FormFeedback>* This field is required</FormFeedback> */}
        </FormGroup>

        <FormGroup className="d-flex justify-content-between">
          {type === '2fa' && (
            <Button
              disabled={disable2FaOtp}
              color="primary"
              className="otp-buttons"
              onClick={this.on2FaApp}
            >
              {(disable2FaOtp) ? `Enter 2FA App OTP Code, ${seconds} sec` : 'Use 2FA App'} 
            </Button>
          )}
          {type === '2fa' && this.userData.phoneNumber && (
            <Button
              disabled={disableSendSms}
              color="primary"
              className="otp-buttons"
              onClick={this.onSendSms}
              id="send-via-SMS"
            >
              {(disableSendSms) ? `Didn't get the code? Resend after ${seconds} sec` : 'Send via SMS'}
            </Button>
          )}
          {type === '2fa' && (
            <Button
              disabled={disableSendEmail}
              color="primary"
              className="otp-buttons"
              onClick={this.sendEmail}
              id="send-via-Email"
            >
              {(disableSendEmail)
                ? `Didn't get the code? Resend after ${seconds} sec`
                : 'Send via Email'}
            </Button>
          )}

          <Button color="primary" type="submit" className="otp-buttons" id="login">
            {type === '2fa' ? 'Verify' : 'Login'}
          </Button>
          <Link className="reset-password-forgot" to="/reset-password" id="reset-password-forgot">
            Password Reset
          </Link>
        </FormGroup>
        {type === '2fa' && this.userData.phoneNumber && (
          <p style={{ color: '#8998ac' }}>SMS verification number is {this.userData.phoneNumber}</p>
        )}
      </Form>
    );
  }
}

export default LoginForm;
